export enum MutationTypes {
    LOAD_ADMIN = 'LOAD_ADMIN',
    LOAD_HISTORY = 'LOAD_HISTORY',
}
